import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { FormValidationService } from 'src/app/core/services/form-validation.service';
import { SubscriptionItemService, SubscriptionOrderCustomer } from 'src/app/core/services/subscription-item.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';

@Component({
	selector: 'app-subscription-checkout',
	templateUrl: './subscription-checkout.component.html',
	styleUrls: ['../subscription.scss'],
})
export class SubscriptionCheckoutComponent implements OnInit, OnDestroy {
	@Input() displayCart: boolean;
	@Output() displayCartChange = new EventEmitter<boolean>();
	modalVisible: boolean = true;

	cartSubscription: Subscription;

	checkoutSection: GenericLabelValue[] = [
		{
			label: 'Cart',
			value: 'cart',
			disabled: false,
			selected: true,
			sortVal: 0,
		},
		{
			label: 'Bill To',
			value: 'bill',
			disabled: false,
			sortVal: 1,
		},
		{
			label: 'Ship To',
			value: 'ship',
			disabled: false,
			sortVal: 2,
		},
		{
			label: 'Payment Information',
			value: 'payment',
			disabled: false,
			sortVal: 3,
		},
		{
			label: 'Confirmation',
			value: 'confirmation',
			disabled: false,
			sortVal: 4,
		},
	];

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		public customerService: CustomerService,
		public validatorService: FormValidationService,
		private subscriptionItemService: SubscriptionItemService
	) {}
	ngOnDestroy(): void {
		this.cartSubscription.unsubscribe();
	}

	ngOnInit(): void {
		this.cartSubscription = this.subscriptionItemService.cartItems.subscribe((data) => {
			if (data.length === 0) {
				this.displayCartChange.emit(false);
				this.displayCart = false;
			}
		});

		const ship = this.checkoutSection.find((i) => i.value === 'ship');
		if (ship && !ship.disabled) {
			this.subscriptionItemService.customer.shipTo = new SubscriptionOrderCustomer();
		}
	}

	evalCompletedFormSection(index: number) {
		let nextIndex = index + 1;
		if (nextIndex === this.checkoutSection.length) {
			return;
		}

		if (this.checkoutSection[nextIndex].disabled) {
			this.evalCompletedFormSection(nextIndex);
		}
		this.checkoutSection[index].selected = false;
		this.checkoutSection[nextIndex].selected = true;
	}
}
